import React from "react";
import Wrp from "../../../hoc/Wrp/Wrp";
import { isSet } from "../../../Utils/CommonFunctions";
import { getOutputFieldsElement,isValidJson } from "../MarkupFunctions";

const ScmOutputTextField = ({ attributes, elmtParams })=>{
    const {convertAndRenderElement} = elmtParams;
    const {loopData,dataTable,dynamicVar,children,childActionButtons} = elmtParams;
    // const {outputResponse} = defProps;

    const dataElmt = getOutputFieldsElement(attributes,elmtParams);
    // const dataElmtStr = isValidJson(dataElmt) ? JSON.stringify(dataElmt) : dataElmt;
    // const dataElmt = getOutputFieldsElement(attributes,elmtParams);
    // const dataElmtStr = isValidJson(dataElmt) ? JSON.stringify(dataElmt) : dataElmt;
    let dataElmtStr;
    if (React.isValidElement(dataElmt)) {
    // It's already a React element, keep as is
    dataElmtStr = dataElmt;
    } else if (isValidJson(dataElmt)) {
    // It's JSON text
    dataElmtStr = JSON.stringify(dataElmt);
    } else {
    // It's plain string or other
    dataElmtStr = dataElmt;
    }
    return React.createElement(
        Wrp, 
        {...attributes},
        convertAndRenderElement([{
                data:dataElmtStr,
                type:'text'
            },...isSet(children,[])],{
                loopData,
                dataTable,
                dynamicVar,
                childActionButtons}));
    
}

ScmOutputTextField.defaultProps = {
    attributes:{},
    elmtParams:{}
}
export default ScmOutputTextField;